import React, { FC } from 'react';
import { EstablishmentTypeInputProps } from './EstablishmentTypeInputProps';
import useTranslation from '../../hooks/useTranslation';
import InputField from '@ingka/input-field';

const EstablishmentTypeInput: FC<EstablishmentTypeInputProps> = ({
  defaultValue,
}) => {
  const t = useTranslation();
  return (
    <InputField
      id={'establishment-type-input-id'}
      type={'text'}
      label={t('labels.establishmentType')}
      value={defaultValue}
      readOnly
    />
  );
};

export default EstablishmentTypeInput;
